import React from "react";
import { Container, Row, Col } from "react-bootstrap";


export default function Footer() {
    return (
        <>
            <footer className="footer-mainbg py-5">
                <Container>
                    <Row className="justify-content-center text-center">
                        {/* Logo Section */}
                        <Col md={12} className="mb-4 logo-align">
                            <img src="images/Logo.jpg" alt="Logo" style={{ marginBottom: "20px" }} />
                        </Col>
                    </Row>
                    <Row>
                        {/* Email Address Section */}
                        <Col md={4} className="mb-3 text-center">
                            <h5 className="fw-bold mb-3" style={{ color: "#3d97d3" }}>Email Address:</h5>
                            <p style={{ color: "#000" }}>
                                <i className="fa fa-envelope" style={{ color: "#3d97d3" }}></i>&nbsp;
                                info@digisoft.qa
                            </p>
                        </Col>
                        {/* Address Section */}
                        <Col md={4} className="mb-3 text-center">
                            <h5 className="fw-bold" style={{ color: "#3d97d3" }}>Address:</h5>
                            <p style={{ lineHeight: "1.8", color: "#000" }}>
                                <i className="fa fa-location-dot" style={{ color: "#3d97d3" }}></i>&nbsp;
                                No 51, 5<sup>th</sup> Floor, Al EZZ Tower 4,<br />
                                Street No 840, Zone 18,<br />
                                Al Safiliya, Doha, Qatar.
                            </p>
                        </Col>

                        {/* Contact Section */}
                        <Col md={4} className="mb-3 text-center">
                            <h5 className="fw-bold" style={{ color: "#3d97d3" }}>Contact Number:</h5>
                            <p style={{ color: "#000" }}>
                                <i className="fa-solid fa-phone "
                                    style={{ color: "#3d97d3" }}></i>
                                <span className="px-3">
                                    +974 51852341 <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    +974 66730852
                                </span>
                            </p>
                        </Col>



                        {/* Social Media Icons */}
                        <Col md={12} className="mt-4">
                            <div className="d-flex justify-content-center gap-4">
                                <a href="#" style={{ color: "#3d97d3" }}>
                                    <i className="fab fa-twitter fa-lg"></i>
                                </a>
                                <a href="#" style={{ color: "#3d97d3" }}>
                                    <i className="fab fa-facebook fa-lg"></i>
                                </a>
                                <a href="#" style={{ color: "#3d97d3" }}>
                                    <i className="fab fa-instagram fa-lg"></i>
                                </a>
                                <a href="#" style={{ color: "#3d97d3" }}>
                                    <i className="fab fa-youtube fa-lg"></i>
                                </a>
                                <a href="https://www.linkedin.com/company/digisoft-technology-and-consulting-services/?viewAsMember=true"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "#3d97d3" }}>
                                    <i className="fab fa-linkedin fa-lg"></i>
                                </a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
            {/* Copyright Section */}
            <div className="text-center mt-4 copyright-section">
                <p className="mb-0">
                    Copyright © 2024 Digisoft. Designed and Developed <span><a href="https://dgbirdmedia.com/" target="_blank" style={{ textDecorationLine: 'none' }}>DGBird Media</a></span>.
                </p>
            </div>
        </>
    )
}